import { convertToRaw, convertFromRaw } from 'draft-js'

function mentionBuild(textBlock, mentions) {
  const mention = textBlock.match(/<@(USER|ORG):(\d+)>/)

  if (mention && mention[1]) {
    return mentions
      .filter(({ type }) => type === mention[1])
      .find(({ id }) => id === parseInt(mention[2], 10))
  }

  // eslint-disable-next-line no-undefined
  return undefined
}

function mentionCreate(text, textBlock, mentions, entityMap, entityRanges) {
  const mention = mentionBuild(textBlock, mentions)

  // eslint-disable-next-line no-undefined
  if (mention === undefined) {
    return textBlock
  }

  const entityKey = Object.keys(entityMap).length

  // build the entitymap with immutable
  entityMap[entityKey] = {
    type: mention.type === 'USER' ? 'mention' : '!mention',
    mutability: 'IMMUTABLE',
    data: { mention },
  }

  // build the entity rage for the block
  entityRanges.push({
    key: entityKey,
    length: mention.name.length,
    offset: text.length,
  })

  return mention.name
}

// this is a helper function to parse each individual line and build out the req'd
// data structure needed for draftjs to populate the form with correctly.
function parse(line, entityMap, mentions) {
  const entityRanges = []
  const lineBlocks = line.split(' ')

  let text = ''

  // we work with each individual text chunk since its easier to do data manipulation
  // with it that way. mentions are stored in a way that there are no spaces so this
  // works properly.
  for (let textBlock of lineBlocks) {
    textBlock = mentionCreate(text, textBlock, mentions, entityMap, entityRanges)

    text += `${textBlock} `

  }
  return {
    entityRanges,
    entityMap,
    text: text.trim(),
  }
}

// this takes the plaintext content we are storing in the database and rebuilds
// the draftjs data structure so it works with the required details.
export function toJS(content, mentions) {
  const lines = content.split('\n')
  const blocks = []

  let entityMap = {}

  for (let i = 0; i < lines.length; i++) {
    const result = parse(lines[i], entityMap, mentions)

    blocks.push({
      text: result.text,
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: result.entityRanges,
    })
    entityMap = result.entityMap
  }

  return convertFromRaw({ blocks, entityMap })
}

// eslint-disable-next-line complexity
function processTextMention(textBlock, entity, entityRange) {
  if (entity.type === 'mention' || entity.type === '!mention') {
    for (let idx = entityRange.offset; idx < entityRange.offset + entityRange.length; idx++) {
      textBlock[idx] = null
    }

    textBlock[entityRange.offset] = `<@${entity.data.mention.type}:${entity.data.mention.id}>`
  }
}

function processBlock(block, entityMap) {
  const textBlock = block.text.split('')

  for (const entityRange of block.entityRanges) {
    const entity = entityMap[entityRange.key]

    processTextMention(textBlock, entity, entityRange)
  }

  return textBlock.join('')
}

// this converts the DraftJS output to a plaintext format that can be stored in the
// database with the format we care about. mentions are stored in a special format
// that we care about.
export function toMD(contentState) {
  const { blocks, entityMap } = convertToRaw(contentState)

  return blocks
    .map((block) => processBlock(block, entityMap))
    .join('\n')
}

export default {
  toJS,
  toMD,
}
